import { LEADS_DEFAULT_FIELDS } from './leads';

export enum ACTIVITIES_DEFAULT_FIELDS {
  PRODUCTS = LEADS_DEFAULT_FIELDS.PRODUCTS,
  ACTIVITY_TYPE = LEADS_DEFAULT_FIELDS.ACTIVITY_TYPE,
}
